<template>
  <div class="d-md-none sm-menu-holder" style="height: 100%;">
    <!-- SM MENU -->
    <div class="flex" style="justify-content: flex-start; height: 100%; align-items: center;">
      <div class="sm-menu-toggle btn btn-default btn-sm" @click="toggleSmMenu">
        Menu
      </div>
    </div>
    <div class="sm-menu" :class="{'hidden': !show}">
      <menu-items></menu-items>
    </div>
  </div>
</template>
<script>
  import MenuItems from './Menu.vue'

  export default {
    components: {
      MenuItems,
    },
    created() {
      this.$root.$on('sm-menu-close', () => {
        this.show = false
      })
    },
    data() {
      return {
        show: false,
      }
    },
    methods: {
      toggleSmMenu() {
        this.show = !this.show
      }
    }
  }
</script>
<style lang="scss">
  .sm-menu-holder {

    .sm-menu-toggle {
      height: fit-content;
      margin-left: 15px;
    }

    .sm-menu {
      &.hidden {
        display: none;
      }

      position: fixed;
      top: 60px;
      right: 0;
      background: white;
      border-top: 1px solid #ccc;
      height: calc(100vh - 60px);
      width: 100%;
      z-index: 10;

      .m-menu__nav {
        padding: 0;
        height: 100%;
        display: block !important;

        .m-menu__item {
          text-align: left;
          padding-left: 10px;
          margin-top: 10px;
          font-size: 1.5rem;
          width: auto;
        }
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/SmMenu.vue